import { changeCellStyle, excelExport } from "components/CommonLib/CommonLib";

export const exportToExcel = (data, fileName) => {
  const newData = [];
  for (let i = 0; i < data.length; i++) {
    const row = {};
    row.층 = changeCellStyle(data[i]?.floor_name ?? "", "", "left");
    row.구역 = changeCellStyle(data[i]?.zone_name ?? "", "", "left");
    row.락커번호 = changeCellStyle(data[i]?.locker_no ?? "", "", "center");
    row.비밀번호 = changeCellStyle(data[i]?.locker_info?.password ?? "", "", "center");
    row.회원번호 = changeCellStyle(data[i]?.locker_info?.member_info?.member_no ?? "", "", "left");
    row.회원명 = changeCellStyle(data[i]?.locker_info?.member_info?.member_name ?? "", "", "left");
    row.연락처 = changeCellStyle(data[i]?.locker_info?.member_info?.phone ?? "", "", "left");
    row.사용종료일 = changeCellStyle(data[i]?.mbshp_to_date ?? "", "", "left");

    newData.push(row);
  }

  const lastRow = {};
  lastRow.층 = changeCellStyle("총 락커수", "lightOrange", "left");
  lastRow.구역 = changeCellStyle(data.length, "", "left");

  newData.push(lastRow);
  // 헤더 스타일 정의
  const headerStyle = {
    fill: { fgColor: { theme: 4, tint: 0.8 } },
    alignment: { horizontal: "left" },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    },
  };

  excelExport(newData, fileName, 15, headerStyle);
};
